import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ACCESS_TYPES } from '../../services/content_v1';
import MultiSelect from './MultiSelect';

interface PermissionerProps {
    value?: ACCESS_TYPES,
    label?: string,
    selectLabel?: string,
    availUsers: { label: string, value: number }[],
    placeholder: string,
    setValue: (val: ACCESS_TYPES) => void
    userList: number[],
    setUserList?: (val: number[]) => void
    'data-test-id'?: string,
}

function Permissioner({ label, placeholder, selectLabel, value, setValue, availUsers, userList, setUserList, 'data-test-id': testId }: PermissionerProps) {
    const { t } = useTranslation();

    const permissions = [
        { value: ACCESS_TYPES.ALL, label: t('All') },
        { value: ACCESS_TYPES.FAVORITES, label: 'VIP' },
        { value: ACCESS_TYPES.LIST, label: t('List') },
        { value: ACCESS_TYPES.NOBODY, label: t('Nobody') },
    ];

    const [permission, setPermission] = useState(value);
    const [localUsers, setLocalUsers] = useState<number[]>(userList);

    useEffect(() => {
        setLocalUsers(userList);
    }, [userList]);

    useEffect(() => {
        setPermission(value);
    }, [value]);

    return <div className="form__item">
        <label htmlFor="" className="form__label">{label}</label>
        <ul className="form__radio-list content-add__view-access" data-test-id={testId}>
            {permissions.map(p =>
                <li key={p.value}>
                    <label
                        className={'radio' + (p.value === permission ? ' radio-checked' : '')}
                        onClick={() => {
                            setPermission(p.value);
                            setValue(p.value);
                        }}
                    >
                        {p.label}
                    </label>
                </li>
            )}
        </ul>

        {permission === ACCESS_TYPES.LIST && <MultiSelect
            className="form__item content-add__show-hide-target"
            label={selectLabel}
            value={localUsers}
            options={availUsers}
            placeholder={placeholder}
            setValue={setLocalUsers}
            onChange={(options) => setUserList && setUserList(options.map(option => option.value))}
        />}
    </div>
}

export default Permissioner;